var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconReset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 5.00003V3.21003C12.0002 2.76003 11.4602 2.54003 11.1502 2.86003L8.3502 5.65003C8.1502 5.85003 8.1502 6.16003 8.3502 6.36003L11.1402 9.15003C11.4602 9.46003 12.0002 9.24003 12.0002 8.79003V7.00003C15.3102 7.00003 18.0002 9.69003 18.0002 13C18.0002 15.72 16.1702 18.02 13.6902 18.75C13.2702 18.87 13.0002 19.27 13.0002 19.7C13.0002 20.35 13.6202 20.86 14.2502 20.67C17.5702 19.7 20.0002 16.64 20.0002 13C20.0002 8.58003 16.4202 5.00003 12.0002 5.00003Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13.0001C6 11.6601 6.44 10.4201 7.19 9.41009C7.49 9.01009 7.45 8.46009 7.1 8.10009C6.68 7.68009 5.96 7.72009 5.6 8.20009C4.6 9.54009 4 11.2001 4 13.0001C4 16.6401 6.43 19.7001 9.75 20.6701C10.38 20.8601 11 20.3501 11 19.7001C11 19.2701 10.73 18.8701 10.31 18.7501C7.83 18.0201 6 15.7201 6 13.0001Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReset);
export default __webpack_public_path__ + "static/media/icon-reset.17b330c4a32879df17e1d74907eecd54.svg";
export { ForwardRef as ReactComponent };